export default __webpack_public_path__ + "static/media/header@2x.01ba1b2e.jpg";